import MyTabs from '../../../components/MyTabs';
import Preface from './Preface';

const Introduction = (props) => {
  
    const tabs = [
        { id: "preface", title: "Preface", Component: Preface },
      ];

return (
    <>
        <MyTabs list={tabs}/>
    </>
)
};

export default Introduction;